import { useContext } from 'react'

import {
  DynamicIslandActionsContext,
  DynamicIslandRowsContext,
} from './DynamicIslandProvider'

// Most consumers only need pushRows/popRows (stable actions).
// Use useDynamicIslandActions() to avoid re-renders from rows changes.
export const useDynamicIslandActions = () => {
  return useContext(DynamicIslandActionsContext)
}

export const useDynamicIslandRows = () => {
  return useContext(DynamicIslandRowsContext)
}
